import { useEffect, useState } from "react";
import {
  Item,
  ItemResponse,
  ScheduledAssessment,
} from "@dimensional-engineering/dimensional-models";

import styles from "./TraitsAssessmentModal.module.css";

import {
  handlePeerItemAnswerScroll,
  handlePeerItemAnswerUndoScroll,
} from "@/components/peerAssessments/utils";
import { useAuth } from "@/context/AuthContext";
import {
  getMissingItems,
  removeDuplicateItemResponses,
  saveTraitAssessmentResponse,
} from "../utils";
import ProgressBar from "@/components/shared/Progressbar/ProgressBar";
import AssessmentBackButton from "@/components/assessments-new/AssessmentBackButton/AssessmentBackButton";

type Props = {
  items: Item[];
  itemResponses: ItemResponse[];
  slug: string;
  type: "element" | "pattern";
  scheduledAssessment: ScheduledAssessment;
  onFinish: (itemResponses: ItemResponse[]) => void;
};

export default function TraitAssessmentItemsView(props: Props) {
  const { user } = useAuth();

  const [responses, setResponses] = useState<ItemResponse[]>([]);
  const [items, setItems] = useState<Item[]>([]);

  const answerList = items[responses.length]?.options;

  useEffect(() => {
    setItems(props.items);
    setResponses(props.itemResponses);

    // setItems(filteredItems);
  }, [props.itemResponses, props.items]);

  useEffect(() => {
    const missingItems = getMissingItems(props.items, responses);
    if (responses.length === items.length && items.length > 0) {
      if (missingItems.length === 0) {
        props.onFinish(removeDuplicateItemResponses(responses));
      } else {
        missingItems.forEach((i) => {
          setItems((current) => [...current, i]);
        });
      }
    }
  }, [responses, items]);

  function handleAnswer(option: any, item: Item) {
    setTimeout(() => {
      handlePeerItemAnswerScroll();
    }, 50);
    const response: ItemResponse = {
      createdOn: Date.now(),
      dimensionSlug: item.dimensionSlug,
      itemId: item.slug,
      itemText: item.text,
      scaleSlugs: item.scaleSlugs,
      selectedOption: {
        text: option.text,
        value: option.value,
      },
    };

    saveTraitAssessmentResponse(response, props.scheduledAssessment, user?.uid)
      .then(() => {
        setResponses((current) => [...current, response]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const mapped = answerList?.map((option, index) => {
    return (
      <div
        className={styles.item}
        onClick={() => {
          const target = document.getElementById(`answerBox${index}`);
          if (target) {
            target.classList.add("active");
            setTimeout(() => {
              target.classList.remove("active");
            }, 200);
          }
          handleAnswer(option, items[responses.length]);
        }}
        id={`answerBox${index}`}
        key={option.slug}
      >
        <p>{option.text}</p>
      </div>
    );
  });

  return (
    <section id="mainAssessment" className={styles.assessmentMain}>
      <ProgressBar total={items.length} current={responses.length} />
      <div id="carouselContainer" className={styles.assessmentWrapper}>
        <p className={styles.leadInText}>
          {items[responses.length]?.leadInText}
        </p>
        <p className={styles.text}>{items[responses.length]?.text}</p>
        <div className={styles.itemWrapper}>{mapped}</div>
        {responses.length ? (
          <div className={styles.backButton}>
            <AssessmentBackButton
              onClick={() => {
                handlePeerItemAnswerUndoScroll();
                setTimeout(() => {
                  setResponses((prev) => prev.slice(0, -1));
                }, 50);
              }}
            />
          </div>
        ) : null}
      </div>
    </section>
  );
}
